import * as yup from 'yup';
import { getRequiredTextMessage } from '../index';
export const refundSchema = maxAmount => yup.object({
  amount: yup.number().positive().max(maxAmount).required('Refund amount is a required!'),
  notes: yup.string().nullable(true)
});
export const refundInitialValues = {
  amount: undefined,
  notes: ''
};
export const creditInitialValues = {
  amount: undefined,
  memo: '',
  notes: ''
};
export const creditSchema = () => yup.object({
  amount: yup.number().positive(),
  memo: yup.string().nullable(true),
  notes: yup.string().nullable(true)
});
export const verifyPaymentInitialValues = {
  amount: undefined,
  memo: '',
  notes: '',
  postDate: '',
  referenceNumber: '',
  type: ''
};
export const verifyPaymentSchema = () => yup.object({
  amount: yup.number().positive().required(),
  memo: yup.string(),
  notes: yup.string(),
  postDate: yup.string().required(),
  referenceNumber: yup.string().required(),
  type: yup.string().required()
});
export const postChargeCreditInitialValues = {
  title: '',
  amount: undefined,
  memo: '',
  notes: '',
  notifyResident: false,
  type: 'Miscellaneous',
  postType: 'OneTime'
};
export const postChargeCreditSchema = () => yup.object({
  title: yup.string().when('postType', {
    is: value => value,
    then: schema => schema.required(getRequiredTextMessage('Title')).max(60, 'Title is too long'),
    otherwise: schema => schema.nullable().optional().max(60, 'Title is too long')
  }),
  amount: yup.number().positive().required(),
  memo: yup.string(),
  notes: yup.string(),
  notifyResident: yup.boolean(),
  type: yup.string()
});